import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import {
  border,
  color,
  margin,
  p1Styles,
  p2styles,
  p3styles,
  pad,
  styles,
  table1,
} from "./styles/pdf2Style";
import { t1Headers, t2Data, t2Headers, table1Data } from "./datas";
import getColumnWidth from "../utils/getColoumnWidth";

function addSpaceAfterLetter(word, index = 6) {
  if (word.length > 7) {
    // Check if the word is long enough to add a space
    return word.slice(0, index) + " " + word.slice(index); // Add a space after the 6th letter
  } else {
    return word; // If the word is 7 characters or shorter, return it as is
  }
}

const Page2 = ({ generatedTitles, FEES_PAYABLE, combinedData }) => {
  if (generatedTitles?.length > 0) {
    generatedTitles = [{ col: "S.NO", title: "S.NO" }, ...generatedTitles];
    // generatedTitles = generatedTitles?.filter(
    //   (titles) => titles.col !== "TOTAL MONTHLY PER HEAD COST"
    // );
    generatedTitles = [
      ...generatedTitles,
      // {
      //   col: "TOTAL MONTHLY PER HEAD COST",
      //   title: "TOTAL MONTHLY PER HEAD COST",
      // },
    ];
  }

  const T1ColumnWidths = new Array(11).fill(95 / 9);
  T1ColumnWidths[0] = 5;
  const T2ColumnWidths = [10, 30, 30, 30];
  console.log("print the value in console",combinedData)
  return (
    <View style={styles.content}>
      <Text style={[styles.bold, margin.my10]}>Table 1: MONTHLY FEES:</Text>
      <View>
        <View
          style={[table1.table, color.bgGray, styles.bold, { borderLeft: 1 }]}
        >
          {generatedTitles?.length > 0 &&
            generatedTitles?.map((heading, i) => {
              return (
                <View
                  key={heading.title}
                  style={[
                    table1.cell,
                    {
                      // width:  `${ i==0   ? '5%' : 95/(t1Headers?.length-1)+'%' }`
                      width: `${100 / generatedTitles.length}%`,
                    },
                  ]}
                >
                  <Text style={[styles.wrap, styles.textCenter]} break>
                    {heading?.col?.toUpperCase()}
                  </Text>
                </View>
              );
            })}
        </View>
        <View>
          {combinedData?.map((data, i) => {
            return (
              <View style={[table1.table, { borderLeft: 1 }]} key={i}>
                <View
                  key={0}
                  style={[
                    table1.cell,
                    { width: `${100 / generatedTitles.length}%` },
                  ]}
                >
                  <Text style={[styles.wrap, styles.textCenter]} break>
                    {i + 1}
                  </Text>
                </View>
                {generatedTitles.length > 0 &&
                  generatedTitles?.map((header, headerIndex) => {
                    if (headerIndex > 0) {
                      return (
                        <React.Fragment key={header.col}>
                          {header?.basic ||
                          header.col ===
                            "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)" ? (
                            <View
                              style={[
                                table1.cell,
                                {
                                  width: `${100 / generatedTitles.length}%`,
                                },
                              ]}
                            >
                              <Text
                                style={[styles.wrap, styles.textCenter]}
                                break
                              >
                                {addSpaceAfterLetter(
                                  String(data[header?.title]),
                                  6
                                )}
                              </Text>
                            </View>
                          ) : (
                            <View
                              style={[
                                table1.cell,
                                {
                                  width: `${100 / generatedTitles.length}%`,
                                },
                              ]}
                            >
                              <Text
                                style={[styles.wrap, styles.textCenter]}
                                break
                              >
                                {
                                  data?.data?.find(
                                    (item) => item.heading === header?.title
                                  )?.cost
                                }
                              </Text>
                            </View>
                          )}
                        </React.Fragment>
                      );
                    } else return null;
                  })}
              </View>
            );
          })}
        </View>
      </View>
      <Text style={[styles.bold, margin.mt12]}>
        The provided Monthly fee includes Saudization/Nitaqat, Admin Cost &
        Service fee only. The Monthly cost will vary for Technical & Engineer
        positions - Electrician, Plumber, Mechanic, Comp. Operator, Draftsman,
        Engineer, Computer Programmer etc.
      </Text>
      <Text style={[margin.my12]}>
        All of the above charges are excluding 15% VAT. 15% VAT will be
        applicable and added to all invoices, Governmental and Non-Governmenta
      </Text>

      {/* Table 2 */}
      <View style={[color.bgBlack, styles.textCenter, pad.a5]}>
        <Text style={[color.textWhite, styles.bold]}>
          FEES PAYABLE BY SECOND PARTY
        </Text>
      </View>
      <View>
        <View
          style={[table1.table, color.bgGray, styles.bold, { borderLeft: 1 }]}
        >
          {t2Headers?.map((heading, i) => {
            return (
              <View
                key={heading}
                style={[
                  table1.cell,
                  {
                    width: T2ColumnWidths[i] + "%",
                  },
                ]}
              >
                <Text style={[styles.wrap, styles.textCenter]}>{heading}</Text>
              </View>
            );
          })}
        </View>
        <View>
          {FEES_PAYABLE?.map((data, i) => {
            return (
              <View style={[table1.table]} key={i}>
                <View
                  key={0}
                  style={[
                    table1.cell,
                    pad.y5,
                    { width: T2ColumnWidths[0] + "%", borderLeft: 1 },
                  ]}
                >
                  <Text style={[styles.wrap, styles.textCenter]} break>
                    {i + 1}
                  </Text>
                </View>
                <View
                  key={1}
                  style={[
                    table1.cell,
                    ,
                    pad.y5,
                    { width: T2ColumnWidths[1] + "%" },
                  ]}
                >
                  <Text style={[styles.wrap, styles.textCenter1]} break>
                    {data?.item}
                  </Text>
                </View>
                <View
                  key={1}
                  style={[
                    table1.cell,
                    pad.y5,
                    { width: T2ColumnWidths[2] + "%" },
                  ]}
                >
                  <Text style={[styles.wrap, styles.textCenter]} break>
                    {data?.cost}
                  </Text>
                </View>
                <View
                  key={1}
                  style={[
                    table1.cell,
                    pad.y5,
                    { width: T2ColumnWidths[3] + "%" },
                  ]}
                >
                  <Text style={[styles.wrap, styles.textCenter1]} break>
                    {data?.remark}
                  </Text>
                </View>
              </View>
            );
          })}
        </View>
      </View>
    </View>
  );
};

export default Page2;
